module.exports = __webpack_public_path__ + "img/interface OneB Url-editor_1 prew.2dfbd66a.jpg";